// extracted by mini-css-extract-plugin
export default {"listagem_titulo":"home_listagem_titulo__YBfX1","listagem_subtitulo":"home_listagem_subtitulo__EKq5y","paragrafo":"home_paragrafo__Q8FRi","BannerInt":"home_BannerInt__Sa+fL"};